export default "__VITE_ASSET__BRhEqBI3__"